import UnitRatioStatus, { IUnitRatioStatusAPI } from './UnitRatioStatus';

interface Comparator<T> {
  (a: T, b: T): number;
}

export interface IUnitRatioStatusesAPI {
  standard_ratios: IUnitRatioStatusAPI[];
  nonstandard_ratios: IUnitRatioStatusAPI[];
}

export default class UnitRatioStatuses {
  standardRatios: UnitRatioStatus[];

  nonstandardRatios: UnitRatioStatus[];

  comparer: Comparator<UnitRatioStatus>;

  constructor(standardRatios: UnitRatioStatus[], nonstandardRatios: UnitRatioStatus[]) {
    this.standardRatios = standardRatios;
    this.nonstandardRatios = nonstandardRatios;

    this.comparer = (a, b) => (a.unitCount > b.unitCount ? -1 : a.unitCount < b.unitCount ? 1 : 0);
  }

  get all(): UnitRatioStatus[] {
    const all = [...(this.standardRatios ?? []), ...(this.nonstandardRatios ?? [])];
    return all.sort(this.comparer);
  }

  static fromApi(apiObject: IUnitRatioStatusesAPI): UnitRatioStatuses {
    const model = new UnitRatioStatuses(
      apiObject.standard_ratios?.map((x: any) => UnitRatioStatus.fromApi(x)) ?? [],
      apiObject.nonstandard_ratios?.map((x: any) => UnitRatioStatus.fromApi(x)) ?? [],
    );

    model.nonstandardRatios = model.nonstandardRatios.sort(model.comparer);
    model.standardRatios = model.standardRatios.sort(model.comparer);

    return model;
  }

  toApi(): IUnitRatioStatusesAPI {
    return {
      standard_ratios: this.standardRatios?.map((x) => x.toApi()),
      nonstandard_ratios: this.nonstandardRatios?.map((x) => x.toApi()),
    };
  }
}
